export default "__VITE_ASSET__29ded2f4__"